export const REQUEST_PROFILE_WIDGET_EDIT_LABEL_FIELD_NAME_LABELS = 'labels'
